import { ForgetPasswordStyleModel } from "./model/forget-password-style-model";
import { ForgetPasswordView } from "./model/forget-password-view.enum";
import { ForgetPasswordModel } from "./model/forget-password-model";
import { FormBuilder, FormGroup, AbstractControl, FormControl, Validators, ReactiveFormsModule } from "@angular/forms";
import { Component, inject, output, input } from "@angular/core";
import { PasswordValidator } from "./validator/password-validator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-forget-password",
  templateUrl: "./forget-password.component.html",
  standalone: true,
  imports: [ReactiveFormsModule, TranslatePipe],
})
export class ForgetPasswordComponent {
  readonly model = input.required<ForgetPasswordModel>();
  readonly style = input<ForgetPasswordStyleModel>({} as ForgetPasswordStyleModel);

  readonly usernameEmitted = output<string>();
  readonly codeEmitted = output<string>();
  readonly newPasswordEmitted = output<string>();
  readonly #formBuilder = inject(FormBuilder);

  readonly views = ForgetPasswordView;

  readonly userForm: FormGroup = this.#formBuilder.group({
    login: [],
  });
  readonly codeForm: FormGroup = this.#formBuilder.group({
    code: [],
  });
  readonly passwordForm = new FormGroup(
    {
      password: new FormControl("", [Validators.required]),
      passwordConfirmation: new FormControl("", [Validators.required]),
    },
    {
      validators: [PasswordValidator.passwordConfirmationFailed],
    }
  );

  public onUserFormSubmit(userFormValue: { login: string }): void {
    this.usernameEmitted.emit(userFormValue.login);
  }

  public onCodeFormSubmit(codeFormValue: { code: string }): void {
    this.codeEmitted.emit(codeFormValue.code);
  }

  public onPasswordFormSubmit(passwordFormValue: { password: string; passwordConfirmation: string }): void {
    this.newPasswordEmitted.emit(passwordFormValue.password);
  }

  public get login(): AbstractControl {
    return this.userForm.get("login") as AbstractControl;
  }
  get code(): AbstractControl {
    return this.codeForm.get("code") as AbstractControl;
  }
  get password(): AbstractControl {
    return this.passwordForm.get("password") as AbstractControl;
  }
  get passwordConfirmation(): AbstractControl {
    return this.passwordForm.get("passwordConfirmation") as AbstractControl;
  }
}
